export enum LocationsFilterUpdateEnum {
    COUNTRY = 'Country',
    STATE_REGION = 'State/Region',
    ZIP_METRO = 'ZIP/Metro'
}
